import moment from 'moment-timezone';
import { MNSproCloudApi } from '..';
import {
  CockpitBannerResponse,
  CockpitWidgetsConfigurationItem,
  TimeTableSubstitutionsOfMeResponse,
} from '../api/v2';

export class CockpitService {
  private static getApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.CockpitApiFactory(config);

    return api;
  }

  static async getCockpitWidgetsConfiguration(
    authToken: string,
    organizationId: string,
  ): Promise<CockpitWidgetsConfigurationItem> {
    const api = CockpitService.getApi(authToken);
    const response = await api.getCockpitWidgetsConfiguration(organizationId);

    return response.data;
  }

  static async createOrUpdateCockpitWidgetsConfiguration(
    authToken: string,
    organizationId: string,
    cockpitWidgetsConfigurationItem: CockpitWidgetsConfigurationItem,
  ): Promise<CockpitWidgetsConfigurationItem> {
    const api = CockpitService.getApi(authToken);
    const response = await api.createOrUpdateCockpitWidgetsConfiguration(
      organizationId,
      cockpitWidgetsConfigurationItem,
    );

    return response.data;
  }

  static async getMyCockpitWidgets(authToken: string, organizationId: string): Promise<string[]> {
    const api = CockpitService.getApi(authToken);
    const response = await api.getMyCockpitWidgets(organizationId);

    return response.data;
  }

  static async getCockpitBanner(
    authToken: string,
    organizationId: string,
  ): Promise<CockpitBannerResponse> {
    const api = CockpitService.getApi(authToken);
    const response = await api.getCockpitBanner(organizationId);

    return response.data;
  }

  private static getClassRegisterApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);

    return api;
  }

  static async getMySubstitutions(
    authToken: string,
    organizationId: string,
    dayCount: number = 2,
  ): Promise<TimeTableSubstitutionsOfMeResponse> {
    const api = CockpitService.getClassRegisterApi(authToken);
    const start = moment().toISOString().split('T')[0];
    const response = await api.getMySubstitutions(organizationId, start, dayCount);

    return response.data;
  }
}
